import React from 'react';
import { motion } from 'framer-motion';
export function Header() {
  return <header className="w-full py-8 text-center border-b border-brown-light/30 bg-cream" data-id="element-99">
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto px-4" data-id="element-100">
        <h1 className="font-handwriting text-5xl md:text-6xl text-forest mb-2" data-id="element-101">
          Napftagebuch
        </h1>
        <p className="font-serif text-brown-dark/70 italic text-lg" data-id="element-102">
          Ehrliche Geschichten aus dem Hundealltag
        </p>
      </motion.div>
    </header>;
}